/**
 * Team Tab Component for Admin Panel
 */
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Users, Plus, X, Loader2 } from 'lucide-react';
import { getRoleBadge } from './adminHelpers';

export const TeamTab = ({
  team,
  teamLoading,
  showAddMember,
  setShowAddMember,
  newMember,
  setNewMember,
  addTeamMember,
  removeTeamMember
}) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-base flex items-center gap-2">
            <Users className="w-4 h-4" /> Team Members
          </CardTitle>
          <Button size="sm" onClick={() => setShowAddMember(true)}>
            <Plus className="w-4 h-4 mr-1" /> Add Member
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {showAddMember && (
          <div className="mb-6 p-4 bg-zinc-50 rounded-lg border">
            <div className="flex items-center justify-between mb-3">
              <h4 className="font-medium">Add Team Member</h4>
              <Button variant="ghost" size="sm" onClick={() => setShowAddMember(false)}><X className="w-4 h-4" /></Button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
              <Input placeholder="Email" value={newMember.email} onChange={(e) => setNewMember({...newMember, email: e.target.value})} />
              <Input placeholder="Name (optional)" value={newMember.name} onChange={(e) => setNewMember({...newMember, name: e.target.value})} />
              <select value={newMember.role} onChange={(e) => setNewMember({...newMember, role: e.target.value})} className="border rounded px-3 py-2 text-sm">
                <option value="design_reviewer">Design Reviewer</option>
                <option value="qa">QA Tester</option>
              </select>
              <Button onClick={addTeamMember}>Add</Button>
            </div>
          </div>
        )}

        {teamLoading ? (
          <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-amber-600" /></div>
        ) : team.length === 0 ? (
          <div className="text-center py-12 text-zinc-500">
            <Users className="w-12 h-12 mx-auto mb-3 text-zinc-300" />
            <p>No team members yet</p>
            <p className="text-xs mt-1">Add Design Reviewers and QA testers</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-zinc-200">
                  <th className="text-left py-2 px-2 font-medium text-zinc-600">Member</th>
                  <th className="text-left py-2 px-2 font-medium text-zinc-600">Email</th>
                  <th className="text-left py-2 px-2 font-medium text-zinc-600">Role</th>
                  <th className="text-left py-2 px-2 font-medium text-zinc-600">Added</th>
                  <th className="text-left py-2 px-2 font-medium text-zinc-600">Actions</th>
                </tr>
              </thead>
              <tbody>
                {team.map(member => (
                  <tr key={member.member_id} className="border-b border-zinc-100 hover:bg-zinc-50">
                    <td className="py-2 px-2 font-medium">{member.name || '-'}</td>
                    <td className="py-2 px-2 text-zinc-600">{member.member_email}</td>
                    <td className="py-2 px-2">{getRoleBadge(member.role)}</td>
                    <td className="py-2 px-2 text-xs text-zinc-500">{new Date(member.created_at).toLocaleDateString()}</td>
                    <td className="py-2 px-2">
                      <Button variant="ghost" size="sm" className="text-red-600 hover:text-red-700" onClick={() => removeTeamMember(member.member_email)}>
                        Remove
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TeamTab;
